import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
/**
 * 建具自動生成確認ダイアログ
 * 3D遷移時に１Fに建具があるかチェックして、ない場合に表示
 */
class ConfirmGenerateFittingsDialog3 extends Dialog {
  /**
     * コンストラクタ
     */
  constructor(draggable: boolean) {
    super(draggable);

    // ダイアログのコンテンツ生成
    const id = 'confirmGenerateFittingsDialog';
    let title = '';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'en': title = 'Automatic joinery generation'; break;
      default: title = '建具自動生成'; break;
    }

    let contents = '<div class="confirmGenerateFittings">\n';
    contents += '<span class="jp">1Fに建具が配置されていません。<br>1Fに建具を自動生成しますか？</span><span class="en">No fittings placed on the 1st floor.<br>Would you like to run the auto fitting generation?</span>';
    contents += '</div>\n';

    let footer = '<button value="true"><span class="jp">はい</span><span class="en">Yes</span></button>';
    footer += '<button><span class="jp">いいえ</span><span class="en">No</span></button>';

    this.createDialog(id, title, contents, footer);
    this.viewObj.querySelectorAll('button').forEach((element) => {
      element.addEventListener('click', this.btnEventHandler);
    });
  }

    /**
     * ボタンがクリックされた
     */
    btnEventHandler = (e) => {
      this.close();
      e.preventDefault();
      if ((e.currentTarget).value) {
        // 1Fを表示
        marietta.webcad.WebCADGlobal.changeFloor(1);
        marietta.webcad.WebCADGlobal.cadAPIManager.generateFittings(() => {
          marietta.webcad.WebCADGlobal.dimensionMenu.checkModelParam(marietta.webcad.WebCADGlobal.dimensionMenu.changeMode3D);
        });
      } else {
        marietta.webcad.WebCADGlobal.dimensionMenu.checkModelParam(marietta.webcad.WebCADGlobal.dimensionMenu.changeMode3D);
      }
    }
}
export default ConfirmGenerateFittingsDialog3;
